var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 20.5H3.9V9.9h3.2Zm-1.6-12a1.86 1.86 0 1 1 0-3.72 1.86 1.86 0 0 1 0 3.72ZM20.5 20.5h-3.2v-5.15c0-1.23-.02-2.8-1.71-2.8-1.71 0-1.97 1.34-1.97 2.72v5.23H10.4V9.9h3.07v1.45h.04a3.37 3.37 0 0 1 3.03-1.66c3.24 0 3.84 2.13 3.84 4.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d56fef545d6b12ee3c5570d2c79fd2ca.svg";
export { ForwardRef as ReactComponent };